// Client-side validation utilities
// No backend dependencies - pure frontend validation

export const validateName = (name) => {
  if (!name || name.trim() === '') {
    return 'Name is required';
  }
  if (name.trim().length < 2) {
    return 'Name must be at least 2 characters long';
  }
  if (name.trim().length > 50) {
    return 'Name must not exceed 50 characters';
  }
  if (!/^[a-zA-Z\s]+$/.test(name)) {
    return 'Name can only contain letters and spaces';
  }
  return '';
};

export const validateEmail = (email) => {
  if (!email || email.trim() === '') {
    return 'Email is required';
  }
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (!emailRegex.test(email)) {
    return 'Please enter a valid email address';
  }
  return '';
};

export const validatePassword = (password) => {
  if (!password) {
    return 'Password is required';
  }
  if (password.length < 8) {
    return 'Password must be at least 8 characters long';
  }
  if (!/(?=.*[a-z])/.test(password)) {
    return 'Password must contain at least one lowercase letter';
  }
  if (!/(?=.*[A-Z])/.test(password)) {
    return 'Password must contain at least one uppercase letter';
  }
  if (!/(?=.*\d)/.test(password)) {
    return 'Password must contain at least one number';
  }
  return '';
};

export const validateConfirmPassword = (password, confirmPassword) => {
  if (!confirmPassword) {
    return 'Please confirm your password';
  }
  if (password !== confirmPassword) {
    return 'Passwords do not match';
  }
  return '';
};

export const validateOTP = (otp) => {
  if (!otp || otp.trim() === '') {
    return 'OTP is required';
  }
  if (!/^\d{6}$/.test(otp)) {
    return 'OTP must be exactly 6 digits';
  }
  return '';
};

export const validateFullName = (fullName) => {
  if (!fullName || fullName.trim() === '') {
    return 'Full Name is required';
  }

  const trimmed = fullName.trim();

  if (!/^[a-zA-Z\s]+$/.test(trimmed)) {
    return 'Full Name can only contain letters and spaces';
  }

  if (trimmed.length < 3) {
    return 'Full Name must be at least 3 characters long';
  }

  if (trimmed.length > 30) {
    return 'Full Name must not exceed 30 characters';
  }

  return '';
};

export const validateUsername = (username, required = false) => {
  if (!username || username.trim() === '') {
    return required ? 'Username is required' : '';
  }

  const trimmedUsername = username.trim();

  if (trimmedUsername.length < 3) {
    return 'Username must be at least 3 characters long';
  }

  if (trimmedUsername.length > 30) {
    return 'Username must not exceed 30 characters';
  }

  if (!/^[a-zA-Z\s]+$/.test(trimmedUsername)) {
    return 'Username can only contain letters and spaces';
  }

  return '';
};

// Password strength checker
export const getPasswordStrength = (password) => {
  let strength = 0;
  
  if (password.length >= 8) strength++;
  if (password.length >= 12) strength++;
  if (/(?=.*[a-z])/.test(password)) strength++;
  if (/(?=.*[A-Z])/.test(password)) strength++;
  if (/(?=.*\d)/.test(password)) strength++;
  if (/(?=.*[!@#$%^&*])/.test(password)) strength++;
  
  if (strength <= 2) return { label: 'Weak', color: 'red', percentage: 33 };
  if (strength <= 4) return { label: 'Medium', color: 'yellow', percentage: 66 };
  return { label: 'Strong', color: 'green', percentage: 100 };
};